import { NgModule } from '@angular/core';
import { WishlistCmsComponents } from '@core/const';
import { WishListUiModule } from '@sdvor/wishlist/ui';
import { ConfigModule } from '@spartacus/core';
import {
  WISHLIST_FEATURE_LAZY,
  WISHLIST_UI_WISHLIST_BUTTON_LAZY,
  WISHLIST_UI_WISHLIST_CONTENT_LAZY,
} from '@wishlist/const';

@NgModule({
  imports: [
    ConfigModule.withConfig({
      featureModules: {
        [WISHLIST_FEATURE_LAZY]: {
          module: () => import('./lazy/wishlist-feature.module').then((m) => m.WishlistFeatureLazyModule),
        },
        [WISHLIST_UI_WISHLIST_BUTTON_LAZY]: {
          module: () => import('./lazy/wishlist-button.module').then((m) => m.WishlistButtonLazyModule),
          cmsComponents: [WishlistCmsComponents.RosaCMSWishlistButtonComponent],
        },
        [WISHLIST_UI_WISHLIST_CONTENT_LAZY]: {
          module: () => import('./lazy/wishlist-content.module').then((m) => m.WishlistContentLazyModule),
          cmsComponents: [WishlistCmsComponents.RosaCMSWishlistContentComponent],
        },
      },
    }),
    WishListUiModule,
  ],
})
export class WishlistShellModule {}
